
  import * as falIcons from './classic/light.mjs';

  

  


var byPrefixAndName = {'fal': {},};
var all = [];

function addIcons (icons) {
  Object.keys(icons).forEach(function (iconName) {
    if (iconName === 'prefix') {
      return;
    }

    var icon = icons[iconName];
    var aliases = icon.icon[2];
    aliases.forEach(function (alias) {
      if (typeof alias === 'string') {
        byPrefixAndName[icon.prefix][alias] = icon;
      }
    })
    byPrefixAndName[icon.prefix][icon.iconName] = icon;
    all.push(icon);
  });
}


  
  addIcons(falIcons);
  var fal = falIcons;
  

  

  


export {
  byPrefixAndName, all
  , fal
}
